import React from "react";
import { createPortal } from "react-dom";
import SBINModal from "./modals/SBINModal";

export default function ConfirmDialog({
  isOpen,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  variant = "default",
}) {
  if (!isOpen) return null;

  if (variant === "taxExempt") {
    return (
      <SBINModal
        isOpen={isOpen}
        onClose={onCancel}
        title={title}
        size="sm"
        fitContent={true}
        footer={
          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              onClick={onCancel}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="rounded-full bg-rose-500 px-5 py-2 text-sm font-semibold text-white hover:bg-rose-600"
            >
              {confirmLabel}
            </button>
          </div>
        }
      >
        <p className="text-sm text-slate-700 whitespace-pre-line">{message}</p>
      </SBINModal>
    );
  }

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="relative z-[10000] bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="px-6 pt-5 pb-3 border-b border-slate-200">
          <h2 className="text-base font-semibold text-slate-900">{title}</h2>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm text-slate-700 whitespace-pre-line">
            {message}
          </p>
        </div>

        <div className="px-6 pb-4 pt-2 flex justify-end gap-3 border-t border-slate-200">
          <button
            type="button"
            className="px-4 py-2 text-sm rounded border border-slate-300 text-slate-700 hover:bg-slate-50"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="px-4 py-2 text-sm rounded bg-emerald-600 text-white hover:bg-emerald-700"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
